// currency input directive
import { Directive, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[Currency]',
  host: {
    '(keydown)': 'currency($event)',
    '(focus)': 'setCurrency($event)',
    '(keyup)': 'formatCurrency($event)',
  },
})
export class CurrencyDirective {
  constructor(private readonly el: ElementRef) {}
  // array of valids keys  for currency input
  private validKeys = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Del',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ];

  currency(event: KeyboardEvent) {
    if (!this.validKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  formatCurrency(event: KeyboardEvent) {
    let value = (event.target as HTMLInputElement).value.replace(/\D/g, '');

    this.el.nativeElement.value = (Number(value) / 100).toFixed(2);

    event.target.dispatchEvent(new Event('input'));
  }

  setCurrency(event) {
    let input = event.target as HTMLInputElement;
    input.value = input.value == '' ? '0.00' : input.value;

    event.target.dispatchEvent(new Event('input'));
  }
}
